import React from 'react'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import EventIcon from '@mui/icons-material/Event'
import useStyles from '@screens/AppointmentConfirmation/Body/styles'
import { useDateFnsLocale } from '@hooks/useDateFnsLocale'
import { TEST_IDS } from 'src/constants/testIds'
import { DATE_FORMATS } from 'src/config/constants'
import { useLanguage } from '@hooks/useLanguage'
import { CustomerLastName } from '@screens/AppointmentConfirmation/Body/CustomerLastName'

interface RecallDetailsProps {
  selectedSlot: Date
  treatment?: TreatmentBundle
}

export const RecallDetails = ({ selectedSlot, treatment }: RecallDetailsProps) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const locale = useDateFnsLocale()
  const language = useLanguage()

  return (
    <div data-test="bookingInfo" className={classes.informationContainer}>
      <div className={classes.iconContainer}>
        <EventIcon className={classes.eventIcon} />
      </div>
      <div className={classes.infoDetailsContainer}>
        <CustomerLastName />

        {treatment?.titleKey && (
          <div className={classes.description} data-test={TEST_IDS.treatmentName}>
            {t(treatment.titleKey)}
          </div>
        )}

        <div className={classes.description} data-test={TEST_IDS.appointmentDate}>
          {format(selectedSlot, DATE_FORMATS.APPOINTMENT_CONFIRMATION[language], { locale })}
        </div>
      </div>
    </div>
  )
}
